import { useState } from "react";
import '../css/cseDeptStyle.css';

const CtlCenter = () => {

    const [activeTab, setActiveTab] = useState("v-pills-Awards");
    const [peopleTab, setPeopleTab] = useState("Faculty");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        console.log(tabId)
    }

    const handlePeopleTabClick = (tabId) => {
        setPeopleTab(tabId);
        console.log(tabId)
    }
    return (
        <><div class="dept-wrapper">
            <div class="container">
                <section class="py-4 header">
                    <header>
                        {/* */}
                        {/*<img src="CSEDeptAssets/images/CS-banner_NITW-new.png" class="img-fluid"/>*/}
                        <img
                            src="https://nitw.ac.in/api/static/files/CtlCenter_2025-7-19-11-54-0.jpg" class="img-fluid" />
                    </header>
                    <div class="row">
                        <div class="col-md-3">
                            {/* Tabs nav */}
                            <div class="nav flex-column nav-pills nav-pills-custom" id="v-pills-tab" role="tablist"
                                aria-orientation="vertical">
                                {/*<a class="nav-link    active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true"><span>Home</span></a>*/}
                                <a class={`nav-link ${activeTab === 'v-pills-Awards' ? 'active' : ''}`} id="v-pills-Awards-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-Awards')}
                                    role="tab" aria-controls="v-pills-Awards"
                                    aria-selected={activeTab === 'v-pills-Awards' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-Awards' ? '#c20315' : '#00FFFF' }}> <span>About</span> </a>



                                <a class={`nav-link ${activeTab === 'v-pills-Faculty' ? 'active' : ''}`} id="v-pills-Faculty-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-Faculty')}
                                    role="tab" aria-controls="v-pills-Faculty" aria-selected={activeTab === 'v-pills-Faculty' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-Faculty' ? '#c20315' : '#00FFFF' }}>
                                    <span>People </span>
                                </a>




                                <a href="https://nitw.ac.in/page/?url=ctl" class={`nav-link ${activeTab === 'v-pills-NotableAlumni' ? 'active' : ''}`} id="v-pills-NotableAlumni-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-NotableAlumni')}
                                    role="tab" aria-controls="v-pills-NotableAlumni"
                                    aria-selected={activeTab === 'v-pills-NotableAlumni' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-NotableAlumni' ? '#c20315' : '#00FFFF' }}>
                                    <span>CTL Announcements</span>
                                </a>


                                <a href="https://nitw.ac.in/page/?url=mmtc" class={`nav-link ${activeTab === 'v-pills-academics' ? 'active' : ''}`}
                                    id="v-pills-academics-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-academics')} role="tab"
                                    aria-controls="v-pills-academics" aria-selected={activeTab === 'vv-pills-academics' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-academics' ? '#c20315' : '#00FFFF' }}>
                                    <span>MMTTC Announcements</span>
                                </a>

                            </div>
                            <div class="head_of_dept">
                                <a href="https://erp.nitw.ac.in/ext/profile/ee-sailaja"
                                    target="_blank"> <img src="https://erp.nitw.ac.in/ext/profile/getUserImage/ee-sailaja" alt="" class="img-fluid" width="190" height="220" />
                                    <h6>  Prof. M. Sailaja Kumari</h6>
                                </a>
                                <p class="justified-text">Coordinator, UGC-MMTTC <br/> and Head, CTL, NITW <br />
                                    <a href="mailto:ctl_hod@nitw.ac.in"
                                        style={{ color: "#808080" }}>ctl_hod@nitw.ac.in</a>
                                    <br /> 0870 2462685 </p>
                            </div>
                        </div>



                        <div class="col-md-9">
                            {/* Tabs content */}
                            <div class="tab-content" id="v-pills-tabContent">

                                <div class={`tab-pane ${activeTab === 'v-pills-Faculty' ? 'show active' : 'alumniTabHide'} fade  `} id="v-pills-Faculty" role="tabpanel"
                                    aria-labelledby="v-pills-Faculty-tab">
                                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">


                                         <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'Faculty' ? 'active' : ''} `} id="nav-faculty-tab" data-toggle="tab"
                                            role="tab" aria-controls="nav-faculty"
                                            style={{ backgroundColor: peopleTab === 'Faculty' ? '#c20315' : '#00FFFF' }} onClick={() => { handlePeopleTabClick("Faculty") }}>Office Staff</a>


                                        {/* <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'AdjunctFaculty' ? 'active' : ''} `}
                                            id="nav-AdjunctFaculty-tab" data-toggle="tab"
                                            role="tab" aria-controls="nav-AdjunctFaculty" aria-selected="false" onClick={() => { handlePeopleTabClick("AdjunctFaculty") }}> Adjunct Faculty</a> */}


                                        {/* <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'NonTeachingStaff' ? 'active' : ''} `}
                                            id="nav-NonTeachingStaff-tab" data-toggle="tab"
                                            role="tab" aria-controls="nav-NonTeachingStaff"
                                            style={{ backgroundColor: peopleTab === 'NonTeachingStaff' ? '#c20315' : '#00FFFF' }} onClick={() => { handlePeopleTabClick("NonTeachingStaff") }}>Warden</a> */}


                                        {/* <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'ResearchScholars' ? 'active' : ''} `} id="nav-ResearchScholars-tab"
                                            data-toggle="tab" role="tab"
                                            aria-controls="nav-ResearchScholars"
                                            style={{ backgroundColor: peopleTab === 'ResearchScholars' ? '#c20315' : '#00FFFF' }} onClick={() => { handlePeopleTabClick("ResearchScholars") }}>
                                            Office Staff</a>
 */}

                                    </div>



                                    <div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent"
                                        style={{ marginTop: "5%", marginLeft: "1%" }}>
                                        <div class={`tab-pane ${peopleTab === 'Faculty' ? 'show active' : ''} fade`} id="nav-faculty" role="tabpanel"
                                            aria-labelledby="nav-ResearchScholars-tab">
                                            <div className="row phd-std-row">
                                                <div className="col-md-3 col-6 col-sm-6 mb-5 phd-std-wrap">
                                                    <div className="phd-std-member">
                                                        <div className="phd-std-img">
                                                            <img src="https://nitw.ac.in/api/static/files/Technician_2025-7-18-18-10-4.jpg" className="img-fluid image" alt="" style={{ width: '180px', height: '200px', objectFit: 'cover', }}/>
                                                        
                                                        </div>
                                                        <h6 className="std-title">Mr. V. Sambayya                                                         </h6>
                                                        <span>Technician (SG-II)</span>
                                                        <hr />
                                                        {/* <p className="contact-info">
                                                            {/* 8978567535 <br />   */}
                                                            {/* <span><a href="mailto:cr22btr1r03@student.nitw.ac.in" >Technician (SG-II)</a></span> </p> */}
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-6 col-sm-6 mb-5 phd-std-wrap">
                                                    <div className="phd-std-member">
                                                        <div className="phd-std-img">
                                                            <img src="https://nitw.ac.in/api/static/files/care-taker_2025-7-18-18-9-20.jpg" className="img-fluid image" alt="" style={{ width: '180px', height: '200px', objectFit: 'cover', }} />
                                                           
                                                        </div>
                                                        <h6 className="std-title">Mr. T. Ramesh                                                        </h6>
                                                        <span>Sr. Care Taker </span>
                                                        <hr />
                                                        {/* <p className="contact-info"> */}
                                                            {/* 8978567535 <br />   */}
                                                            {/* <span><a href="mailto:gs23btr1r02@student.nitw.ac.in" >gs23btr1r02@student.nitw.ac.in</a></span> </p> */}
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-6 col-sm-6 mb-5 phd-std-wrap">
                                                    <div className="phd-std-member">
                                                        <div className="phd-std-img">
                                                            <img src="https://nitw.ac.in/api/static/files/Project_Assistant_2025-7-18-18-8-59.jpg" className="img-fluid image" alt="" style={{ width: '180px', height: '200px', objectFit: 'cover', }} />
                                                            
                                                        </div>
                                                        <h6 className="std-title">Mr. V. Pavan Kumar                                                        </h6>
                                                        <span>Project Assistant (MMTTC)</span>
                                                        <hr />
                                                        {/* <p className="contact-info"> */}
                                                            {/* 8978567535 <br />   */}
                                                            {/* <span><a href="mailto:ap720096@student.nitw.ac.in">ap720096@student.nitw.ac.in</a></span> </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class={`tab-pane ${activeTab === 'v-pills-Awards' ? 'show active' : ''} fade  `} id="v-pills-Awards" role="tabpanel"
                                    aria-labelledby="v-pills-Awards-tab">
                                    <p style={{ textAlign: 'justify' }}>
                                        The Centre for Training and Learning (CTL) was established at NIT Warangal in 2015 under the “Malaviya Mission on Teacher Training Program (MMTTP).” This initiative was re-launched on September 5, 2023, by Hon’ble Cabinet Minister for Education, Shri Dharmendra Pradhan, with sponsorship from the University Grants Commission (UGC), Ministry of Education, Government of India. Formerly known as the ‘Teaching Learning Centre’ (TLC), MMTTC has been at the forefront of faculty development and training. Since its inception, the Centre has successfully organized 110 Faculty Development Programmes (FDPs), 12 NEP Orientation Programs, 4 Short-Term Training Program (STTP), 1 Refresher Course, and 4 one-month Faculty Induction Programmes (FIPs). These initiatives have benefitted over 8,000 participants across disciplines such as Science and Technology, Humanities, and Social Sciences.

                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        </>
    );
}

export default CtlCenter;
